import { createApp } from 'vue'
import App from './App.vue'
import i18n from './locales/index'
import { Modal } from 'ant-design-vue';

createApp(App).use(i18n).use(Modal).mount('#app')
